import React from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import { motion } from "framer-motion";
import { Schedule } from "@mui/icons-material";

function SMSTimeSettings({ settings, handleInputChange }) {
  const cardVariants = {
    initial: { scale: 1 },
    hover: { scale: 1.02, boxShadow: "0 10px 20px rgba(0,0,0,0.1)" },
    tap: { scale: 0.98 }
  };

  const handleCustomChange = (e) => {
    const { name, value } = e.target;

    // If value is empty, pass an empty string to indicate optional/unset time
    handleInputChange({
      target: {
        name,
        value: value || "",
        type: "text"
      }
    });
  };

  return (
    <motion.div
      initial={{ y: 40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.3 }}
    >
      <motion.div variants={cardVariants} initial="initial" whileHover="hover">
        <Card className="shadow-sm mb-0">
          <Card.Header className="bg-white py-3">
            <h5 className="mb-0">
              <Schedule className="me-2 text-primary" /> SMS Gönderim Saatleri
            </h5>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col xs={12} md={6} className="mb-3 mb-md-0">
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.1 }}
                  className="border rounded p-3 h-100"
                >
                  <div>
                    <h6 className="fw-bold mb-3">Başlangıç Saati</h6>
                    <Form.Group>
                      <Form.Control
                        type="time"
                        name="smsStartTime"
                        value={settings?.smsStartTime || ""}
                        onChange={handleCustomChange}
                        className="form-control-lg"
                      />
                      <Form.Text className="text-muted">
                        Bu saatten önce SMS gönderimi yapılmayacaktır. Boş bırakılabilir.
                      </Form.Text>
                    </Form.Group>
                  </div>
                </motion.div>
              </Col>
              <Col xs={12} md={6}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2 }}
                  className="border rounded p-3 h-100"
                >
                  <div>
                    <h6 className="fw-bold mb-3">Bitiş Saati</h6>
                    <Form.Group>
                      <Form.Control
                        type="time"
                        name="smsEndTime"
                        value={settings?.smsEndTime || ""}
                        onChange={handleCustomChange}
                        className="form-control-lg"
                      />
                      <Form.Text className="text-muted">
                        Bu saatten sonra SMS gönderimi yapılmayacaktır. Boş bırakılabilir.
                      </Form.Text>
                    </Form.Group>
                  </div>
                </motion.div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12}>
                <div className="border rounded p-3">
                  <div className="text-center text-muted small">
                    Zamanları boş bırakırsanız SMS gönderimi için saat kısıtlaması olmayacaktır.
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </motion.div>
    </motion.div>
  );
}

export default SMSTimeSettings;
